(function fileDownloadControllerDefinition() {
    'use strict';

    angular.module('File')
        .controller('FileDownloadController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'fileService', '$rootScope',
            function fileDownloadController($scope, config, $state, $translate, $stateParams, errors, fileService, $rootScope) {

                //$scope.download = function () { alert(10); };
                $scope.download = function () {

                    alert($stateParams.fileid);

                    fileService.download($stateParams.fileid).then(function (result){
                        var data = atob(result.value.base64File);
                        var uint8Array = new Uint8Array(data, 0, data.length - 1);

                        var octetStreamMime = 'application/octet-stream';
                        var filename = $stateParams.fname;
                        var contentType = octetStreamMime;

                        try {
                            // Try using msSaveBlob if supported
                            console.log("Trying saveBlob method ...");
                            var blob = new Blob(data, { type: contentType });
                            if (navigator.msSaveBlob)
                                navigator.msSaveBlob(blob, filename);
                            else {
                                // Try using other saveBlob implementations, if available
                                var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                                if (saveBlob === undefined) throw "Not supported";
                                saveBlob(blob, filename);
                            }
                            console.log("saveBlob succeeded");
                            success = true;
                        } catch (ex) {
                            console.log("saveBlob method failed with the following exception:");
                            console.log(ex);
                        }
                    });
                }

                $scope.download();
            }
        ]);

})();